import { Switch } from "@shared/components/DataEntry";

import { useActiveCompanySwitch } from "./controller";
import { ActiveCompanySwitchProps } from "./types";

export function ActiveCompanySwitch(props: ActiveCompanySwitchProps) {
  const { isActive, isPending, toggle } = useActiveCompanySwitch(props);

  return (
    <Switch
      checked={isActive}
      onChange={toggle}
      disabled={isPending}
    />
  );
}
